/**
 * Official UTMify tracking script loader.
 * Injects the UTMify pixel/latest script once, on the client only.
 */

const UTMIFY_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js';

export function loadUtmify(): void {
  if (typeof document === 'undefined') return;
  if (document.querySelector(`script[src="${UTMIFY_SRC}"]`)) return;

  const script = document.createElement('script');
  script.src = UTMIFY_SRC;
  script.async = true;
  script.defer = true;
  script.setAttribute('data-utmify-prevent-xcod-sck', '');
  script.setAttribute('data-utmify-prevent-subids', '');
  document.head.appendChild(script);
}
